import React, {useState, useEffect} from 'react'
import './edgetapeRemove.css'

import { getEdgingTapeRowWithOpenSelection } from '../new_order/orderConfig';

function EdgetapeRemove(props) {
    const [rowID, setRowID] = useState(null);

    useEffect(() => {
        const currRowID = getEdgingTapeRowWithOpenSelection();
        setRowID(currRowID + 1);
    }, []);

    const handleContainerClick = (e) => {
        // Check if the click occurred outside the container
        if (e.target.classList.contains('removePopup')) {
            closePopup(); // Close the popup
        }
    };
    const closePopup = () =>{
        props.closeRemoveConfirmationPopup();
    }

    const removeConfirmed = () =>{
        props.removeRow();
        closePopup();
    }

    return (
        <div className='removePopup' onClick={handleContainerClick}>
            <div className='removePopupContainer'>
                <p>Remove edging tape row {rowID}?</p>
                <div className='removePopupBtns'>
                    <div className='removePopupCancel' onClick={() => closePopup()}>
                        <p>Cancel</p>
                    </div>
                    <div className='removePopupConfirm' onClick={() => removeConfirmed()}>
                        <p>Remove</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EdgetapeRemove